'use client'

import { useAtom, useAtomValue, useSetAtom } from 'jotai'
import dynamic from 'next/dynamic'
import { useState } from 'react'

import {
  hedgeDialogFullscreenAtom,
  hedgeDialogOpenAtom,
  hedgeDialogPresetAtom,
} from '@/state/widget-actions'

// Lazy: the builder and its charts are JS nobody needs until the dialog opens, and this host is
// mounted on every trade page.
const HedgeBuilderDialog = dynamic(
  () =>
    import('@/features/hedge/components/hedge-builder-dialog').then((m) => m.HedgeBuilderDialog),
  { ssr: false }
)

// Single always-mounted instance for the whole trade layout — every hedge
// entry point just flips hedgeDialogOpenAtom rather than each owning its own
// dialog. See use-open-hedge-dialog.ts.
export function HedgeBuilderDialogHost() {
  const [open, setOpen] = useAtom(hedgeDialogOpenAtom)
  const [fullscreen, setFullscreen] = useAtom(hedgeDialogFullscreenAtom)
  const preset = useAtomValue(hedgeDialogPresetAtom)
  const setPreset = useSetAtom(hedgeDialogPresetAtom)
  // Mount on first open, then stay mounted so closing still animates out.
  const [hasOpened, setHasOpened] = useState(open)
  if (open && !hasOpened) setHasOpened(true)
  if (!hasOpened) return null
  return (
    <HedgeBuilderDialog
      open={open}
      fullscreen={fullscreen}
      preset={preset}
      onOpenChange={(nextOpen) => {
        setOpen(nextOpen)
        if (!nextOpen) {
          setFullscreen(false)
          setPreset(null)
        }
      }}
    />
  )
}
